<i2a-spinner *ngIf="!profile"></i2a-spinner>

<template i2a-container></template>